import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { useStaticQuery, graphql } from 'gatsby'

import PropTypes from 'prop-types'
import Analytics from 'src/utils/Analytics'

import { CloseButton, PopupOverlay } from '../../Popup/styles'
import {
  PopupContainer,
  Heading,
  SubHeading,
  Disclosure,
  RetailerContainer,
  Card,
  Link,
  LogoWrapper,
} from './styles'
import { LOCALIZATION } from '../../../utils/constants'

const RetailPopup = ({ setDisplayToolTip, isFrame, size }) => {
  const {
    closeIcon,
    amazon,
    bestBuy,
    bjs,
    costco,
    sams,
    target,
    walmart,
    jb,
    currys,
    harvey,
    selfridges,
  } = useStaticQuery(graphql`
    query RetailPopupQuery {
      closeIcon: file(relativePath: { eq: "icons/close-icon.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 28, layout: FIXED, placeholder: NONE)
        }
      }
      amazon: file(relativePath: { eq: "retail/popup/amazon.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 133, placeholder: NONE)
        }
      }
      bestBuy: file(relativePath: { eq: "retail/popup/best-buy.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 101, placeholder: NONE)
        }
      }
      bjs: file(relativePath: { eq: "retail/popup/bjs.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 46, placeholder: NONE)
        }
      }
      costco: file(relativePath: { eq: "retail/popup/costco.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 147, placeholder: NONE)
        }
      }
      sams: file(relativePath: { eq: "retail/popup/sams.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 186, placeholder: NONE)
        }
      }
      target: file(relativePath: { eq: "retail/popup/target.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 52, placeholder: NONE)
        }
      }
      walmart: file(relativePath: { eq: "retail/popup/walmart.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 147, placeholder: NONE)
        }
      }
      jb: file(relativePath: { eq: "retail/popup/jb.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 147, placeholder: NONE)
        }
      }
      currys: file(relativePath: { eq: "retail/popup/currys.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 160, placeholder: NONE)
        }
      }
      harvey: file(relativePath: { eq: "retail/popup/harvey.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 240, placeholder: NONE)
        }
      }
      selfridges: file(relativePath: { eq: "retail/popup/selfridges.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FIXED, width: 240, placeholder: NONE)
        }
      }
    }
  `)

  const CALENDAR_RETAILERS = {
    en: [
      {
        name: 'Amazon',
        link: 'https://www.amazon.com/dp/B0C9V811L6?maas=maas_adg_9BCC914198ACB240F0C87A09423EAC10_afap_abs&ref_=aa_maas&tag=maas',
        logo: amazon,
        id: 'amazon',
      },
      {
        name: 'Best Buy',
        link: 'https://www.bestbuy.com/site/brands/skylight/pcmcat1738271672265.c?id=pcmcat1738271672265',
        logo: bestBuy,
        id: 'bestBuy',
      },
      {
        name: 'Costco',
        link: 'https://www.costco.com/s?keyword=skylight+calendar',
        logo: costco,
        id: 'costco',
      },
      {
        name: 'Target',
        link: 'https://www.target.com/s?searchTerm=Skylight',
        logo: target,
        id: 'target',
      },
      {
        name: 'Walmart',
        link: 'https://www.walmart.com/brand/skylight/10065132',
        logo: walmart,
        id: 'walmart',
      },
      {
        name: `Sam's Club`,
        link: 'https://www.samsclub.com/ip/Skylight-15-Touchscreen-Calendar-Organizer-3-Year-Photo-Videos/13867269032?classType=REGULAR&from=/search',
        logo: sams,
        id: 'sams',
      },
      {
        name: `BJ's`,
        link: 'https://www.bjs.com/product/skylight-15-touchscreen-smart-calendar-and-chore-chart---white/3000000000005805757/',
        logo: bjs,
        id: 'bjs',
      },
    ],
    'en-ca': [
      {
        name: 'Amazon',
        link:
          size === 15
            ? 'https://www.amazon.ca/Skylight-15-Inch-Calendar-Touchscreen-Schedules/dp/B0C9V811L6/ref=sr_1_1_sspa?dib=eyJ2IjoiMSJ9.CwNr3hiyRZ3OPuVf5odTKWDQoUdBkiOYviwQu8NaYADW16fEBOtZh-gLyR7VNDHPpKiAAiAv2pAsfJiv9mOF883Qpixe4Ujjx2IXmhNs0EMVk8OaqlXWt1U57G3TO0evYq0zSSoUMcLbIZ14tJ0AlwLJ0G12MU_ArCa7D3oNaozRuzB4scGaAwHdiHDqIl4SCtmR-hkjdc4_6-UGZ997wrRZMnRb0cBayO2O2kFS7VVTAhwKSeVm1RjVwnt-rgenFNhwAH3rYPBKzkUtph7clShI14tOdfggzq-sbFiCDC4.UBkfh_4YFpBSrwBAyI4JV-QO57k6Z86g9N_ZPh_EEnQ&dib_tag=se&keywords=skylight+calendar&qid=1762381494&sr=8-1-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&psc=1'
            : 'https://www.amazon.ca/Skylight-Calendar-Classic-Translations-Adapter/dp/B0F34Z478Y/ref=sr_1_6?dib=eyJ2IjoiMSJ9.CwNr3hiyRZ3OPuVf5odTKWDQoUdBkiOYviwQu8NaYADW16fEBOtZh-gLyR7VNDHPpKiAAiAv2pAsfJiv9mOF883Qpixe4Ujjx2IXmhNs0EMVk8OaqlXWt1U57G3TO0evYq0zSSoUMcLbIZ14tJ0AlwLJ0G12MU_ArCa7D3oNaozRuzB4scGaAwHdiHDqIl4SCtmR-hkjdc4_6-UGZ997wrRZMnRb0cBayO2O2kFS7VVTAhwKSeVm1RjVwnt-rgenFNhwAH3rYPBKzkUtph7clShI14tOdfggzq-sbFiCDC4.UBkfh_4YFpBSrwBAyI4JV-QO57k6Z86g9N_ZPh_EEnQ&dib_tag=se&keywords=skylight+calendar&qid=1762381494&sr=8-6',
        logo: amazon,
        id: 'amazon',
      },
      {
        name: 'Best Buy',
        link:
          size === 15
            ? 'https://www.bestbuy.ca/en-ca/product/skylight-15-touchscreen-calendar-smart-display-silver-only-at-best-buy/18588522'
            : 'https://www.bestbuy.ca/en-ca/product/skylight-27-touchscreen-calendar-smart-display-white/19352030',
        logo: bestBuy,
        id: 'bestBuy',
      },
      ...(size === 15
        ? [
            {
              name: 'Costco',
              link: 'https://www.costco.ca/skylight-15-in-charcoal-smart-touchscreen-calendar-and-organizer.product.4000369238.html',
              logo: costco,
              id: 'costco',
            },
          ]
        : []),
    ],
    'en-gb': [
      {
        name: 'Amazon',
        link:
          size === 15
            ? 'https://www.amazon.co.uk/Skylight-Calendar-Touchscreen-Interactive-Schedules/dp/B0C9V811L6/ref=sr_1_1?crid=1NYKL1PKVF91Y&dib=eyJ2IjoiMSJ9._dOO-CPab_gIFtqV293qOrvo38cLOcP-7Q6JOy4qGlMV0dwZIeo6hWmHq_BbH8WgpyCrfXOhAnk3Y54gHRlcHUbqTZgAP4_q8Q8gLYdSDfHH8lnemWJtDrRl_7RenZojoxLSskL2B9prPnXazvN0wlaTrDiDGDlk7u_M9Z4UcmGL7S7p_JbQNwAgbsdlxJFSCblz-98AwMVybAI4w_mmsR6Am0FXEUp4mQGcbdgl17tjCQsAXjnKHvRRhSyVXgn09g4jpTALlTZB_c4A18Qx14Fcww4HRgCkDsflXGvphmI.OzD9NdUs3w6s4qXvhlDzmaNuQ9iJ99iMaO-Bq5G1CFY&dib_tag=se&keywords=skylight+calendar&qid=1762381902&sprefix=skylight+calend%2Caps%2C246&sr=8-1'
            : 'https://www.amazon.co.uk/Skylight-Calendar-Max-Interactive-Touchscreen/dp/B0F1WNCX2F/ref=sr_1_6?crid=1NYKL1PKVF91Y&dib=eyJ2IjoiMSJ9._dOO-CPab_gIFtqV293qOrvo38cLOcP-7Q6JOy4qGlMV0dwZIeo6hWmHq_BbH8WgpyCrfXOhAnk3Y54gHRlcHUbqTZgAP4_q8Q8gLYdSDfHH8lnemWJtDrRl_7RenZojoxLSskL2B9prPnXazvN0wlaTrDiDGDlk7u_M9Z4UcmGL7S7p_JbQNwAgbsdlxJFSCblz-98AwMVybAI4w_mmsR6Am0FXEUp4mQGcbdgl17tjCQsAXjnKHvRRhSyVXgn09g4jpTALlTZB_c4A18Qx14Fcww4HRgCkDsflXGvphmI.OzD9NdUs3w6s4qXvhlDzmaNuQ9iJ99iMaO-Bq5G1CFY&dib_tag=se&keywords=skylight+calendar&qid=1762381902&sprefix=skylight+calend%2Caps%2C246&sr=8-6',
        logo: amazon,
        id: 'amazon',
      },
      {
        name: 'Currys',
        link:
          size === 15
            ? 'https://www.currys.co.uk/products/skylight-15-smart-digital-calendar-white-10296309.html?searchTerm=skylight'
            : 'https://www.currys.co.uk/products/skylight--max-27-smart-digital-calendar-white-10296310.html?searchTerm=Skylight',
        logo: currys,
        id: 'currys',
      },
      {
        name: 'Harvey Norman',
        link:
          size === 15
            ? 'https://www.harveynorman.co.uk/products/skylight-15-digital-calendar-150rebi?variant=55384915739000'
            : 'https://www.harveynorman.co.uk/products/skylight-27-digital-calendar-max-270gbx?variant=55384894407032',
        logo: harvey,
        id: 'harveyNorman',
      },
      {
        name: 'Selfridges',
        link:
          size === 15
            ? 'https://www.selfridges.com/GB/en/product/smartech-skylight-digital-calendar-15in_R04587967/#colour=WHITE'
            : 'https://www.selfridges.com/GB/en/product/smartech-skylight-digital-calendar-27in_R04587968/#colour=WHITE',
        logo: selfridges,
        id: 'selfridges',
      },
    ],
    'en-au': [
      ...(size === 15
        ? [
            {
              name: 'Amazon',
              link: 'https://www.amazon.com.au/Skylight-Calendar-Touchscreen-Interactive-Schedules/dp/B0C9V811L6/ref=sr_1_1_sspa?crid=2B3MTFJP1D7TG&dib=eyJ2IjoiMSJ9.nea8OX9QcjWX_EVpbX9jKFMssoSmAhq0K4qMSc4IHQvGLf7Nu1nJQFM5nAi36HnJG7jy_bg2rj_zcWC5ew3G1eGFCtTciQWnGwDmDt3Z6YxPQ4WcSY1G8leRs7kyql3W4kMlkVsOfCf7oc697_qcV81Wa0OuEszupoFtw_mJTEpH3Rs6vd7qrodNw_j6tuiQbBSHSWXuStFTzR5VKV4wjreepeb95qR6p1WcC2j9e6XwkZ2bTh9lwJu7ifZ3TQMmfIPAl7SSc3dlSeRsTJucbQpXwH1QLO-HOd_rrdB6Nlg.vM1q6INoNNYLZDmfSc8NFyHm3VLO4bm4MsP1VayKJGc&dib_tag=se&keywords=skylight+calendar&qid=1762381759&sprefix=%2Caps%2C184&sr=8-1-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&psc=1',
              logo: amazon,
              id: 'amazon',
            },
          ]
        : []),
      {
        name: 'JB HiFi',
        link:
          size === 15
            ? 'https://www.jbhifi.com.au/products/skylight-15-smart-family-calendar-white'
            : 'https://www.jbhifi.com.au/products/skylight-calendar-max-27-white',
        logo: jb,
        id: 'jbhifi',
      },
    ],
  }

  const FRAME_RETAILERS = [
    {
      name: 'Amazon',
      link: 'https://www.amazon.com/dp/B01N7ENHO6?maas=maas_adg_C088DCBAE59917E64090263F547A647A_afap_abs&ref_=aa_maas&tag=maas',
      logo: amazon,
      id: 'amazon',
    },
    {
      name: 'Target',
      link: 'https://www.target.com/s?searchTerm=Skylight',
      logo: target,
      id: 'target',
    },
    {
      name: 'Walmart',
      link: 'https://www.walmart.com/brand/skylight/10065132',
      logo: walmart,
      id: 'walmart',
    },
    {
      name: 'Best Buy',
      link: 'https://www.bestbuy.com/site/brands/skylight/pcmcat1738271672265.c?id=pcmcat1738271672265',
      logo: bestBuy,
      id: 'bestBuy',
    },
  ]

  const retailers = isFrame ? FRAME_RETAILERS : CALENDAR_RETAILERS[LOCALIZATION]

  return (
    <PopupOverlay>
      <PopupContainer>
        <CloseButton onClick={() => setDisplayToolTip(false)}>
          <GatsbyImage image={closeIcon.childImageSharp.gatsbyImageData} alt="Close" />
        </CloseButton>
        <Heading>Get Your Gift ASAP</Heading>
        <SubHeading>
          Check your favorite retailers in-store or online for more ways to get it in time.
        </SubHeading>
        <RetailerContainer>
          {retailers.map((retailer) => (
            <Link
              key={retailer.name}
              href={retailer.link}
              target="_blank"
              rel="noreferrer noopener"
              style={{ marginBottom: '24px', display: 'block' }}
              onClick={() =>
                Analytics.track(
                  `Clicked ${isFrame ? `Frame` : `${size} Calendar`} ${
                    retailer.name
                  } Retail Popup CTA`
                )
              }
            >
              <Card>
                <LogoWrapper>
                  <GatsbyImage
                    image={retailer.logo.childImageSharp.gatsbyImageData}
                    alt={retailer.name}
                    id={retailer.id}
                  />
                </LogoWrapper>

                <span>Shop {retailer.name}</span>
              </Card>
            </Link>
          ))}
        </RetailerContainer>
        <Disclosure>
          Skylight makes no representations, warranties, or guarantees regarding the speed,
          accuracy, or availability of delivery provided by third-party retailers.
        </Disclosure>
      </PopupContainer>
    </PopupOverlay>
  )
}

export default RetailPopup

RetailPopup.propTypes = {
  setDisplayToolTip: PropTypes.func.isRequired,
  isFrame: PropTypes.bool,
  size: PropTypes.number,
}
